import type { NewsItem } from "@/types/movie";

export default function NewsTicker({ items }: { items: NewsItem[] }) {
  const loop = [...items, ...items];

  return (
    <div className="flex items-center gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 px-4 py-3.5 md:px-5">
      <span className="flex shrink-0 items-center gap-2 rounded-md bg-accent-100 px-3 py-1.5 text-sm font-medium text-accent-700">
        <i className="ri-flashlight-fill" />
        资讯快讯
      </span>
      <div className="relative flex-1 overflow-hidden">
        <div className="flex w-max animate-ticker items-center gap-8 hover:[animation-play-state:paused]">
          {loop.map((item, i) => (
            <span key={`${item.id}-${i}`} className="flex shrink-0 items-center gap-2 text-sm text-foreground-700">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
              {item.title}
              <span className="text-xs text-foreground-400">{item.date}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}